import React from 'react';
import { Typography, Paper, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import EventIcon from '@mui/icons-material/Event';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import RepeatIcon from '@mui/icons-material/Repeat';
import GroupIcon from '@mui/icons-material/Group';
import VisibilityIcon from '@mui/icons-material/Visibility';

const DashboardCalendar = () => {
  const features = [
    { 
      icon: <EventIcon />, 
      title: "Schedule AI Interactions", 
      description: "Plan and schedule AI-powered calls and interactions in advance."
    },
    { 
      icon: <NotificationsActiveIcon />, 
      title: "Reminders and Notifications", 
      description: "Set up automated reminders for upcoming AI interactions."
    },
    { 
      icon: <RepeatIcon />, 
      title: "Recurring Events", 
      description: "Create recurring AI interactions for regular check-ins or follow-ups."
    },
    { 
      icon: <GroupIcon />, 
      title: "Team Coordination", 
      description: "Coordinate AI interactions with your team members' schedules."
    },
    { 
      icon: <VisibilityIcon />, 
      title: "Availability Overview", 
      description: "Get a clear view of AI Talker availability and capacity."
    },
  ];

  return (
    <Paper elevation={0}>
      <Typography variant="h4" gutterBottom>Dashboard Calendar</Typography>
      <Typography paragraph>
        The Dashboard Calendar is a powerful tool for managing and scheduling your AI Talker interactions. 
        It provides a comprehensive view of all planned AI engagements, helping you optimize your AI Talker's usage and improve coordination with your team.
      </Typography>
      <Typography variant="h6" gutterBottom>Key Features:</Typography>
      <List>
        {features.map((feature, index) => (
          <ListItem key={index}>
            <ListItemIcon>
              {feature.icon}
            </ListItemIcon>
            <ListItemText 
              primary={feature.title}
              secondary={feature.description}
            />
          </ListItem>
        ))}
      </List>
      <Typography variant="h6" style={{ marginTop: '20px' }}>Using the Calendar:</Typography>
      <Typography paragraph>
        1. Navigate to the Calendar tab in your Dashboard.
      </Typography>
      <Typography paragraph>
        2. Click on any date to schedule a new AI interaction.
      </Typography>
      <Typography paragraph>
        3. Set the duration, frequency (for recurring events), and any specific AI Talker configurations for the interaction.
      </Typography>
      <Typography paragraph>
        4. Use the drag-and-drop feature to easily reschedule events.
      </Typography>
      <Typography paragraph>
        5. Sync the calendar with your preferred calendar application (Google Calendar, Outlook, etc.) for seamless integration with your existing workflow.
      </Typography>
      <Typography paragraph>
        The Dashboard Calendar ensures that you can make the most of your AI Talker's capabilities by efficiently managing its schedule. 
        It helps prevent overbooking, allows for better resource allocation, and provides a clear overview of your AI-powered communication strategy.
      </Typography>
    </Paper>
  );
};

export default DashboardCalendar;
